import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Order } from '../../../order/models/order';
import { environment } from '../../../../../environments/environment';
import { OrderStateService } from '../../services/order-state.service';
import { DiscountStateService } from '../../../payment/services/discount-state.service';
import { PaymentStateService } from '../../../payment/services/payment-state.service';
import { PaymentGiftStateService } from '../../../payment/services/payment-gift-state.service';
import { OrderLine } from '../../models/order-line';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { BasketService } from '../../services/basket.service';
import { BookingOrderService } from 'src/app/modules/booking/services/booking-order.service';
import { ProductPack } from 'src/app/modules/booking/models/product-pack';
import { OrderLineType } from '../../../order/models/order-line-type';

@Component({
  selector: 'app-basket-simple-view',
  templateUrl: 'basket-simple-view.component.html',
  styleUrls: ['basket-simple-view.component.scss']
})
export class BasketSimpleViewComponent {
  @Input() title = 'Order';
  @Input() header: string;
  @Input() allowDeleteLastDate = false;

  @Input()
  readonly = false;

  @Input()
  productPacks: ProductPack[];

  @Input()
  debug = false;

  @Output()
  orderLinesRemovedByDate = new EventEmitter<Date>();

  faTrash = faTrash;

  constructor(
    private orderStateService: OrderStateService,
    private discountStateService: DiscountStateService,
    private paymentGiftStateService: PaymentGiftStateService,
    private paymentStateService: PaymentStateService,
    private basketService: BasketService,
    private bookingOrderService: BookingOrderService,
  ) {
  }

  toMoneyStr(x: number): string {
    return environment.globalSettings.toMoneyStr(x);
  }

  get order(): Order {
    return this.orderStateService.order;
  }

  get discountAmount(): number {
    return this.discountStateService.totalAmountDiscountCoupons;
  }

  get giftcardAmount(): number {
    return this.paymentGiftStateService.totalAmountRedeemedGiftCards;
  }

  get paymentGiftMessage(): string {
    return this.paymentStateService.isPartnerCodePaymentAllowed
      ? 'RFID Card' : 'Gifrcard';
  }

  getOrderLineBookingDateInfo(orderLine: OrderLine): string {
    if (!orderLine || !orderLine.eventDateStart) {
      return '';
    }

    return orderLine.eventDateStart.toLocaleDateString() + ' ' + orderLine.eventDateStart.toLocaleTimeString();
  }

  getGroupHeaderParams(date: Date): any {
    return this.basketService.getGroupHeaderParams(this.order, date);
  }

  get dates(): Date[] {
    return this.basketService.getDates(this.order);
  }

  get datesExist(): boolean {
    return this.dates.filter(date => date).length !== 0;
  }

  getOrderLines(date: Date): OrderLine[] {
    return this.basketService.getOrderLines(this.order, date);
  }

  deleteLinesByDate(date: Date): void {
    if (!this.order || !this.order.orderLines) {
      return;
    }
    const lines = this.getOrderLines(date);
    if (!lines) {
      return;
    }
    for (const line of lines) {
      line.quantity = 0;
      this.order.deleteOrderLine(line);
    }

    this.orderLinesRemovedByDate.emit(date);
  }

  get allowDelete(): boolean {
    return !this.readonly && (this.allowDeleteLastDate || this.dates.length > 1);
  }

  onLoadOrder(): void {
    this.orderStateService.orderLoadFromLocalStorage();
  }

  onSaveOrder(): void {
    this.orderStateService.orderSaveToLocalStorage();
  }

  allowDeleteOrderLine(orderLine: OrderLine) {
    return !this.readonly && orderLine.orderLineType != OrderLineType.AutomaticAdditionalProduct;
  }

  deleteOrderLine(orderLine: OrderLine) {
    if (!this.order || !this.order.orderLines || !orderLine) {
      return;
    }

    orderLine.quantity = 0;
    this.order.deleteOrderLine(orderLine);
    
    if (this.productPacks) {
      for (const productPack of this.productPacks) {
        const products = productPack.products;
        let isProductPackFound = false;
        for (const product of products) {
          if (product.id != orderLine.productId) {
            continue;
          }
          productPack.updateCounter(product, 0);
          isProductPackFound = true;
          break;
        }
        if (isProductPackFound) {
          break;
        }
      }
    }
  }
}
